import { FC, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { RightAeroIcon } from '../../../../svg/RightAeroIcon'
// import { industryOptions } from "./Step1Sub3";
const Step1Sub4: FC<any> = ({ submitLoanComplete, backToLoanEligibility, updateApplication }) => {
  // const [emi, setEmi] = useState<any>(0);
  // const [interest, setInterest] = useState<any>(0);
  const [presentValue, setPresentValue] = useState<any>(0)

  const loanApplication = useSelector((state: any) => state.kycApplication.loanApplication)
  const loanEligibility = useSelector((state: any) => state.kycApplication.loanEligibility)

  useEffect(() => {
    if (loanApplication && loanEligibility) {
      const {
        // industryType,
        profit,
        totalMonthlyInstallmentsToBanks,
        totalMonthlyInstallmentsToNonBanks,
        totalRevolvingCreditOutstandingToBanks,
        totalRevolvingCreditOutstandingToNonBanks,
      } = loanEligibility

      /* const incomeMargin = 0.1; // 10%in percentange
      const existingDebt = totalMonthlyInstallmentsToBanks + totalMonthlyInstallmentsToNonBanks + totalRevolvingCreditOutstandingToBanks * 0.05 + totalRevolvingCreditOutstandingToNonBanks  * 0.05 ;
      const principal = amountRequested;
      const actualIntrestRate = Number(industryOptions.find((o:any) => o.value === industryType)?.pricing);

      // Monthly interest rate : Divide by 100 to convert to fraction
      const interestRate = actualIntrestRate/1200 ; 
      const tenure = durationInMonths
      //EMI = P × r × (1 + r) n/ ((1 + r) n - 1) where P= Loan amount, r= interest rate, n=tenure in number of months
      const top = Math.pow((1+interestRate), tenure); 
      const bottom = top-1;
      const ratio = top/bottom
      const emi = principal * interestRate * ratio; */

      /* 
      OLD DSR (Debt Service Ratio) CALCULATION
      ---------------------------------------
      This was the previous implementation for calculating the Debt Service Ratio.
      It has been replaced with a new calculation method but kept for reference.
      
      The DSR is calculated as:
      (Total Monthly Debt Obligations / Monthly Net Operating Income) * 100
      
      Where:
      - Total Monthly Debt includes:
        * Monthly installments to banks
        * Monthly installments to non-banks
        * 5% of revolving credit outstanding to banks (estimated monthly payment)
        * 5% of revolving credit outstanding to non-banks (estimated monthly payment)
        * New loan EMI
      - Monthly Net Operating Income is the annual profit divided by 12
      */
      /*
      // Calculate total existing monthly debt obligations
      const existingDebt =
        totalMonthlyInstallmentsToBanks +  // Bank loan installments
        totalMonthlyInstallmentsToNonBanks +  // Non-bank loan installments
        totalRevolvingCreditOutstandingToBanks * 0.05 +  // 5% of bank credit card balance
        totalRevolvingCreditOutstandingToNonBanks * 0.05; // 5% of non-bank credit card balance
      
      // Calculate monthly net operating income from annual profit
      const netOperatingIncome = profit / 12;
      
      // Add new loan EMI to existing debt
      const totalDebts = existingDebt + loanApplication.emi;
      
      // Calculate DSR as a percentage
      const debtRatio = (totalDebts / netOperatingIncome) * 100;
      
      // Set the calculated DSR in state
      setDebtRatio(debtRatio);
      
      // Calculate company's age in years (rounded up)
      const diffYear = Math.ceil(
        (new Date().getTime() - new Date(dateOfIncorporation).getTime()) /
          (1000 * 365 * 60 * 60 * 24)  // Convert milliseconds to days, then to years
      );
      setTimeInBusiness(diffYear);
      */

      // Calculate monthly revolving credit with 6 decimal precision
      const monthlyRevolvingBanks = Number((totalRevolvingCreditOutstandingToBanks / 12).toFixed(6))
      const monthlyRevolvingNonBanks = Number(
        (totalRevolvingCreditOutstandingToNonBanks / 12).toFixed(6)
      )

      // Calculate total loans with 2 decimal precision
      const totalLoans = Number(
        (
          totalMonthlyInstallmentsToBanks +
          totalMonthlyInstallmentsToNonBanks +
          monthlyRevolvingBanks +
          monthlyRevolvingNonBanks
        ).toFixed(6)
      )
      // Keep monthly net operating income at 6 decimal precision
      const monthlyNetOperatingIncome = Number((profit / 12).toFixed(6))

      // Calculate 85% of profit with 2 decimal precision
      const profit85X = Number((0.85 * monthlyNetOperatingIncome).toFixed(6))

      // Final EMI calculation with 2 decimal precision
      const emiAsPerDeclaredFinancials = Number((profit85X - totalLoans).toFixed(6))

      const annualRate = 0.2
      const monthlyRate = annualRate / 12 // 20% annual interest, monthly
      const periods = 6 // 6 months
      const result = calculatePresentValue(monthlyRate, periods, emiAsPerDeclaredFinancials)
      setPresentValue(result)
    }
  }, [loanApplication, loanEligibility])

  function calculatePresentValue(monthlyRate: number, tenure: number, EMI: number) {
    const pv = (EMI * (1 - Math.pow(1 + monthlyRate, -tenure))) / monthlyRate
    return Math.round(pv / 1000) * 1000 // Round to nearest 1000
  }

  return (
    <div className='d-flex flex-column'>
      <h1>{presentValue >= 10000 ? 'Congratulations' : 'Thank you'}</h1>

      {presentValue >= 10000 && (
        <div className='sub-heading mb-10 fs-5'>
          {`Hi  ${loanApplication?.applicantName || 'Applicant Name'}, We are excited to inform you 
          that ${
            loanEligibility?.companyName || 'Company name'
          } maybe eligible for a loan amount of 
          upto SG$ ${
            loanApplication
              ? loanApplication.amountRequested
                  .toString()
                  .replace(/(\d)(?=(\d{3})+(\.(\d){0,2})*$)/g, '$1,')
              : 'XX,XXX,XXX'
          } based 
          on the declarations made by you.`}
        </div>
      )}

      {/* Not eligible if debt ration > 85% or business is less than 2 years old */}
      {!(presentValue >= 10000) && (
        <div className='sub-heading mb-10 fs-5'>
          {`Hi `}
          <strong>{loanApplication?.applicantName}</strong>
          {`, Thank you for providing information for `}
          <strong>{loanEligibility?.companyName}</strong>
          <br />
          <strong style={{ marginTop: '8px', display: 'block', color: 'var(--text-color-2)' }}>
            Please continue to next step
          </strong>
        </div>
      )}

      <div className='d-flex flex-column mt-5'>
        <div className='fs-3 fw-bolder mb-5'>
          You are just 2 more steps away from your submission of loan application
        </div>
      </div>

      <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 mb-5'>
        <KTSVG
          path='/media/icons/duotune/general/gen044.svg'
          className='svg-icon-2x svg-icon-warning svg-icon-warning me-4'
        />
        <div className='d-flex flex-stack flex-grow-1'>
          <div className='fw-bold'>
            <h4 className='text-gray-800 fw-bolder'>Business Loan's Tip</h4>
            <div className='fs-6 text-gray-600'>
              We want you to complete the application submission in a flash and Business Loan
              Application recommends that you prepare few documents ready before you proceed:
            </div>
          </div>
        </div>
      </div>

      <div className='text-center'>
        <img alt='' src={toAbsoluteUrl('/media/alexi/congratulation.png')} className='mw-75' />
      </div>

      <div className='d-flex flex-end'>
        <div>
          <button className='btn btn-lg btn-secondary me-3' onClick={() => backToLoanEligibility()}>
            Recheck Eligibility
          </button>

          <button className='btn btn-lg btn-primary me-3' onClick={() => submitLoanComplete()}>
            {presentValue >= 10000 ? 'Save and Continue' : 'Next'}{' '}
            <RightAeroIcon color='currentColor' />
          </button>
        </div>
      </div>
    </div>
  )
}

export { Step1Sub4 }
